import { jsx as C } from "react/jsx-runtime";
function i(r) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 14 14",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 0.8125C7.14918 0.8125 7.29226 0.871763 7.39775 0.977252C7.50324 1.08274 7.5625 1.22582 7.5625 1.375V6.4375H12.625C12.7742 6.4375 12.9173 6.49676 13.0227 6.60225C13.1282 6.70774 13.1875 6.85082 13.1875 7C13.1875 7.14918 13.1282 7.29226 13.0227 7.39775C12.9173 7.50324 12.7742 7.5625 12.625 7.5625H7.5625V12.625C7.5625 12.7742 7.50324 12.9173 7.39775 13.0227C7.29226 13.1282 7.14918 13.1875 7 13.1875C6.85082 13.1875 6.70774 13.1282 6.60225 13.0227C6.49676 12.9173 6.4375 12.7742 6.4375 12.625V7.5625H1.375C1.22582 7.5625 1.08274 7.50324 0.977252 7.39775C0.871763 7.29226 0.8125 7.14918 0.8125 7C0.8125 6.85082 0.871763 6.70774 0.977252 6.60225C1.08274 6.49676 1.22582 6.4375 1.375 6.4375H6.4375V1.375C6.4375 1.22582 6.49676 1.08274 6.60225 0.977252C6.70774 0.871763 6.85082 0.8125 7 0.8125Z"
        }
      )
    }
  );
}
export {
  i as PlusIcon
};
